export default __webpack_public_path__ + "static/media/dsa.0735e929.png";